import {Injectable} from '@angular/core';
import {TrainSchedule, TrainScheduleExport, TrainScheduleReport, TrainWithSchedule} from "../models/train-schedule";
import {DataImportExportService} from "../../../shared/services/data-import-export.service";
import {TranslateService} from "@ngx-translate/core";


@Injectable({
  providedIn: 'root'
})
export class TrainScheduleExportService {

  constructor(
      private dataImportExportService: DataImportExportService,
      private translate: TranslateService
  ) { }

  public exportTrainScheduleCSV(trainSchedules: TrainSchedule[], exportDate: Date, trainIdentifier: String) {
    let trainScheduleExports = this.createExportData(trainSchedules);
    let exportName = exportDate.toISOString().split('T')[0] + "_schedule";

    this.dataImportExportService.exportCSV(trainScheduleExports, this.createExportColumns(trainIdentifier), exportName, ";");
  }

  public createExportData(trainSchedules: TrainSchedule[]): TrainScheduleExport[] {

    return trainSchedules.map(trainSchedule => {
      let trainScheduleExport: TrainScheduleExport = {
        projectId: trainSchedule.projectId,
        trainId: trainSchedule.trainId,
        serviceId: trainSchedule.timeTableEntry.serviceId,
        start: trainSchedule.timeTableEntry.start,
        end: trainSchedule.timeTableEntry.end,
        startStationAbbr: trainSchedule.timeTableEntry.startStationAbbr,
        endStationAbbr: trainSchedule.timeTableEntry.endStationAbbr
      }
      return trainScheduleExport;
    });
  }

  public createExportColumns(trainIdentifier: String): [string, string][] {
    return [["projectId", this.translate.instant('I18N_CONFIGURATION.PROJECT_ID')],
      ["trainId", this.translate.instant('I18N_SCHEDULING.TRAIN') + " " + trainIdentifier],
      ["serviceId", this.translate.instant('I18N_SCHEDULING.SERVICE_ID')],
      ["start", this.translate.instant('I18N_SCHEDULING.START_TIME_DB_TIMEZONE')],
      ["end", this.translate.instant('I18N_SCHEDULING.END_TIME_DB_TIMEZONE')],
      ["startStationAbbr", this.translate.instant('I18N_SCHEDULING.START_STATION')],
      ["endStationAbbr", this.translate.instant('I18N_SCHEDULING.END_STATION')]];
  }

  public reportTrainScheduleCSV(trainsWithSchedules: TrainWithSchedule[], reportDate: Date) {
    let trainScheduleReports = this.createReportData(trainsWithSchedules);
    let exportName = reportDate.toISOString().split('T')[0] + "_report";

    this.dataImportExportService.exportCSV(trainScheduleReports, this.createReportColumns(), exportName, ";");
  }

  public createReportData(trainsWithSchedules: TrainWithSchedule[]): TrainScheduleReport[] {
    let trainScheduleReports: TrainScheduleReport[] = [];
    trainsWithSchedules.forEach((trainWithSchedules, i) => {
      trainWithSchedules.services?.forEach((trainSchedule) => {
        let existingTrainScheduleReport = trainScheduleReports.find(x => x.mission === trainSchedule.timeTableEntry.serviceId);
        if (existingTrainScheduleReport) {
          existingTrainScheduleReport.voitures = existingTrainScheduleReport.voitures + "\";\"" + trainWithSchedules.officialId;
        } else {
          let trainScheduleReport: TrainScheduleReport = {
            mission: trainSchedule.timeTableEntry.serviceId,
            voitures: trainWithSchedules.officialId
          }
          trainScheduleReports.push(trainScheduleReport);
        }
      });
    });

    return trainScheduleReports;
  }

  public createReportColumns(): [string, string][] {
    return [["mission", this.translate.instant('I18N_SCHEDULING.MISSION')],
      ["voitures", this.translate.instant('I18N_SCHEDULING.VOITURES')]];
  }
}
